import { TicketsBundle } from '../components/common/ticketsBoundles';
import { ExtraTickets } from '../types/generalSettings';

export const checkFreeTicketsError = (
  freeTickets: Array<ExtraTickets>
): boolean => {
  let isError = false;
  freeTickets.map((item) => {
    if (
      item.extra < 0 ||
      isNaN(item.extra) ||
      !item.tickets ||
      item.extra > 2000 ||
      item.tickets > 1000
    ) {
      isError = true;
    }
  });
  // for (let index = 0; index < freeTickets.length; index++) {
  //   if (index !== 0) {
  //     if (
  //       freeTickets[index].tickets <= freeTickets[index - 1].tickets ||
  //       freeTickets[index].extra <= freeTickets[index - 1].extra
  //     ) {
  //       isError = true;
  //     }
  //   }
  // }
  return isError;
};

export const checkTicketsBundlesError = (
  ticketsBundles: Array<TicketsBundle>
): boolean => {
  let isError = false;
  if (ticketsBundles.length >= 2) {
    ticketsBundles.map((item) => {
      if (item < 0 || isNaN(item) || !item || item > 1000) {
        isError = true;
      }
    });
    for (let index = 0; index < ticketsBundles.length; index++) {
      if (index !== 0) {
        if (ticketsBundles[index] <= ticketsBundles[index - 1]) {
          isError = true;
        }
      }
    }
  } else {
    isError = true;
  }

  return isError;
};
